(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ikao-balenciaga-header-fix"]) return;
  try {
    
(() => {
const root=document.querySelector('[data-ikao-lux-header]'),sticky=document.querySelector('[data-ikao-lux-sticky]'),drawer=document.querySelector('[data-ikao-cart-drawer]'),cartBox=document.querySelector('[data-ikao-cart-items]'),wishBox=document.querySelector('[data-ikao-wishlist-items]'),cartTotal=document.querySelector('[data-ikao-cart-total]'),cartCheckout=document.querySelector('[data-ikao-cart-checkout]'),shipText=document.querySelector('[data-ikao-cart-shipping-text]'),shipBar=document.querySelector('[data-ikao-cart-shipping-progress]'),discountBox=document.querySelector('[data-ikao-cart-discount-summary]'),discountName=document.querySelector('[data-ikao-cart-discount-name]'),discountOriginal=document.querySelector('[data-ikao-cart-original-total]'),discountAmount=document.querySelector('[data-ikao-cart-discount-amount]'),sheet=document.querySelector('[data-ikao-cart-size-sheet]'),sheetOptions=document.querySelector('[data-ikao-cart-size-options]');
const i18n=(()=>{const d={cart:'Panier',wishlist:'Favoris',checkout:'Finaliser la commande',sizePrefix:'Taille :',moveToWishlist:'Déplacer vers les favoris',remove:'Supprimer',addToCart:'Ajouter au panier',product:'Produit',emptyWishlist:'Votre liste de favoris est vide.',emptyCart:'Votre panier est vide.',loading:'Chargement...',noSizes:'Aucune taille disponible.',sizeError:'Impossible de charger les tailles.',freeShippingMore:'Ajoutez encore [amount] pour profiter de la livraison gratuite.',freeShippingUnlocked:'Vous avez obtenu la livraison gratuite.',locale:'fr'};try{return Object.assign(d,JSON.parse(document.querySelector('[data-ikao-cart-i18n]')?.textContent||'{}')||{})}catch(e){return d}})();
const rootPath=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/',wishKey='ikaoWishlistItems',freeLimit=9900,fmt=(c,currency)=>new Intl.NumberFormat(i18n.locale||document.documentElement.lang||'fr',{style:'currency',currency:currency||lastCart?.currency||'EUR'}).format((c||0)/100),url=p=>`${rootPath}${p}`.replace(/\/{2,}/g,'/'),esc=v=>String(v||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])),txt=v=>String(v||'').trim(),def=v=>/^(default title|titre par défaut)$/i.test(txt(v)),isSize=n=>/^(taille|size|beden|boyut|größe|groesse)$/i.test(txt(n)),isColor=n=>/^(couleur|color|renk|colour|farbe)$/i.test(txt(n));
const handleize=v=>txt(v).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''),colorPatternLabels=(()=>{try{return JSON.parse(document.querySelector('[data-ikao-color-pattern-label-map]')?.textContent||'{}')||{}}catch(e){return{}}})(),localizedColor=v=>colorPatternLabels[handleize(v)]||txt(v);
let req,lastCart,pending,mode='cart',lastY=window.scrollY,cache=new Map(),labelCache=new Map(),titleCache=new Map();
const labelFromMap=(map,index,value)=>{const b=map&&map.labels&&map.labels[String(index)],k=handleize(value);return b&&b[k]?txt(b[k]):''},colorLabelFromMap=(map,value)=>labelFromMap(map,map&&map.colorIndex,value)||localizedColor(value),labelMapFromNode=node=>{try{return JSON.parse(node?.textContent||'{}')||{}}catch(e){return{}}},findLabelNode=(scope,handle)=>Array.from((scope||document).querySelectorAll('[data-ikao-product-option-label-map]')).find(n=>!handle||n.dataset.productHandle===handle),findLabelMapInDom=handle=>labelMapFromNode(findLabelNode(document,handle)),fetchLabelMap=async handle=>{handle=txt(handle);if(!handle)return{};if(labelCache.has(handle))return labelCache.get(handle);let map=findLabelMapInDom(handle);if(map&&map.labels){labelCache.set(handle,map);return map}try{const r=await fetch(url(`products/${handle}`),{headers:{Accept:'text/html'}}),html=await r.text(),doc=new DOMParser().parseFromString(html,'text/html');map=labelMapFromNode(findLabelNode(doc,handle)||findLabelNode(doc,''))}catch(e){map={}}labelCache.set(handle,map||{});return map||{}},fetchProductTitle=async handle=>{handle=txt(handle);if(!handle)return'';if(titleCache.has(handle))return titleCache.get(handle);let title='';try{const r=await fetch(url(`products/${handle}`),{headers:{Accept:'text/html'}}),html=await r.text(),doc=new DOMParser().parseFromString(html,'text/html');title=txt(doc.querySelector('[data-ikao-pdp] .ikao-pdp__card-head h1,[data-ikao-pdp] h1,.product__title h1,h1')?.textContent||'')}catch(e){title=''}titleCache.set(handle,title);return title};
if(drawer&&drawer.parentElement!==document.body)document.body.appendChild(drawer);
const readWish=()=>{try{const v=JSON.parse(localStorage.getItem(wishKey)||'[]');return Array.isArray(v)?v:[]}catch(e){return[]}},saveWish=a=>{localStorage.setItem(wishKey,JSON.stringify(a));renderWish(a)},setCount=(sel,n)=>document.querySelectorAll(sel).forEach(e=>e.textContent=n||0),setMode=m=>{mode=m==='wishlist'?'wishlist':'cart';if(!drawer)return;drawer.dataset.ikaoCartMode=mode;document.querySelectorAll('[data-ikao-drawer-tab]').forEach(b=>b.classList.toggle('is-active',b.dataset.ikaoDrawerTab===mode));if(cartBox)cartBox.hidden=mode!=='cart';if(wishBox)wishBox.hidden=mode!=='wishlist'},open=m=>{if(!drawer)return;setMode(m||mode);drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('ikao-cart-drawer-open')},close=()=>{drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');document.documentElement.classList.remove('ikao-cart-drawer-open')},closeSheet=()=>{pending=null;sheet?.classList.remove('is-open');sheet?.setAttribute('aria-hidden','true')};
const cartLink=a=>{if(!a)return false;const h=a.getAttribute('href')||'',t=a.textContent.trim().toLowerCase();return h.includes('/cart')||t.startsWith('panier')||t.startsWith('cart')||t.startsWith('warenkorb')},updateCartLinks=n=>{document.querySelectorAll('.ikao-lux-header__actions a,.ikao-lux-header__drawer a,a[href*="/cart"]').forEach(a=>{if(a.closest('[data-ikao-cart-drawer]')||!cartLink(a))return;a.dataset.ikaoCartTrigger='true';a.textContent=n>0?`${i18n.cart} (${n})`:i18n.cart});setCount('[data-ikao-cart-drawer-count]',n)};
const optNamed=(item,test)=>{const o=Array.isArray(item.options_with_values)?item.options_with_values:[],f=o.find(x=>test(x.name));return f?txt(f.value):''},lineSize=item=>optNamed(item,isSize)||[item.option1,item.option2,item.option3].filter(v=>v&&!def(v)).pop()||'',lineColor=item=>optNamed(item,isColor)||[item.option1,item.option2,item.option3].filter(v=>v&&!def(v))[0]||'',lineColorLabel=item=>localizedColor(lineColor(item)),price=(p,c)=>`<p class="ikao-cart-drawer__item-price"><span>${fmt(p)}</span>${c&&c>p?` <s>${fmt(c)}</s>`:''}</p>`;
const addWish=item=>{if(!item||(!item.variantId&&!item.id))return;const id=String(item.variantId||item.id),items=readWish(),old=items.find(x=>String(x.id)===id);old?Object.assign(old,item,{id,quantity:Math.max(old.quantity||1,item.quantity||1)}):items.unshift({...item,id,quantity:item.quantity||1});saveWish(items)};
const toWish=item=>({id:String(item.variant_id||item.key),variantId:item.variant_id,productId:item.product_id,handle:item.handle,title:item.product_title,url:item.url,image:item.image,price:item.final_price,compare:item.original_price,size:lineSize(item),color:lineColorLabel(item),rawColor:lineColor(item),quantity:item.quantity||1});
const cartLine=item=>{const s=lineSize(item),rawColor=lineColor(item),color=lineColorLabel(item),base=item.product_title||i18n.product,title=color?`${base} - ${color}`:base,img=item.image?`<a class="ikao-cart-drawer__thumb" href="${esc(item.url)}"><img src="${esc(item.image)}" alt="${esc(title)}" loading="lazy" data-ikao-line-image></a>`:'<div class="ikao-cart-drawer__thumb"></div>';return `<article class="ikao-cart-drawer__item" data-ikao-line-handle="${esc(item.handle)}" data-ikao-line-title-base="${esc(base)}" data-ikao-line-color="${esc(rawColor)}">${img}<div class="ikao-cart-drawer__item-info"><div class="ikao-cart-drawer__item-head"><a class="ikao-cart-drawer__item-title" href="${esc(item.url)}" data-ikao-line-title>${esc(title)}</a>${price(item.final_price,item.original_price)}</div><div class="ikao-cart-drawer__item-controls"><button class="ikao-cart-drawer__size-select" type="button" data-ikao-size-open="cart" data-line-key="${esc(item.key)}"><span>${esc(i18n.sizePrefix)} ${esc(s?String(s).toUpperCase():'-')}</span><span>⌄</span></button><div class="ikao-cart-drawer__qty"><button type="button" data-ikao-qty-change data-line-key="${esc(item.key)}" data-qty="${Math.max((item.quantity||1)-1,0)}">−</button><span>${item.quantity||1}</span><button type="button" data-ikao-qty-change data-line-key="${esc(item.key)}" data-qty="${(item.quantity||1)+1}">+</button></div></div><div class="ikao-cart-drawer__actions"><button class="ikao-cart-drawer__link-button" type="button" data-ikao-move-wishlist data-line-key="${esc(item.key)}">${esc(i18n.moveToWishlist)}</button><button class="ikao-cart-drawer__link-button" type="button" data-ikao-remove-line data-line-key="${esc(item.key)}">${esc(i18n.remove)}</button></div></div></article>`};
const wishLine=item=>{const id=esc(item.id),baseTitle=item.title||i18n.product,rawColor=txt(item.rawColor||item.color),color=txt(item.color),title=color&&baseTitle.indexOf(` - ${color}`)===-1?`${baseTitle} - ${color}`:baseTitle,u=item.url||(item.handle?`/products/${item.handle}`:'#'),img=item.image?`<a class="ikao-cart-drawer__thumb" href="${esc(u)}"><img src="${esc(item.image)}" alt="${esc(title)}" loading="lazy" data-ikao-line-image></a>`:'<div class="ikao-cart-drawer__thumb"></div>';return `<article class="ikao-cart-drawer__item" data-ikao-line-handle="${esc(item.handle||'')}" data-ikao-line-title-base="${esc(baseTitle)}" data-ikao-line-color="${esc(rawColor)}">${img}<div class="ikao-cart-drawer__item-info"><div class="ikao-cart-drawer__item-head"><a class="ikao-cart-drawer__item-title" href="${esc(u)}" data-ikao-line-title>${esc(title)}</a>${item.priceText?`<p class="ikao-cart-drawer__item-price"><span>${esc(item.priceText)}</span></p>`:price(item.price||0,item.compare||0)}</div><div class="ikao-cart-drawer__item-controls"><button class="ikao-cart-drawer__size-select" type="button" data-ikao-size-open="wishlist" data-wishlist-id="${id}"><span>${esc(i18n.sizePrefix)} ${esc(item.size?String(item.size).toUpperCase():'-')}</span><span>⌄</span></button><div class="ikao-cart-drawer__qty"><button type="button" data-ikao-wishlist-qty data-wishlist-id="${id}" data-qty="${Math.max((item.quantity||1)-1,1)}">−</button><span>${item.quantity||1}</span><button type="button" data-ikao-wishlist-qty data-wishlist-id="${id}" data-qty="${(item.quantity||1)+1}">+</button></div></div><div class="ikao-cart-drawer__actions"><button class="ikao-cart-drawer__link-button" type="button" data-ikao-wishlist-add-cart data-wishlist-id="${id}">${esc(i18n.addToCart)}</button><button class="ikao-cart-drawer__link-button" type="button" data-ikao-wishlist-remove data-wishlist-id="${id}">${esc(i18n.remove)}</button></div></div></article>`};
const hydrateLineLabels=box=>{if(!box)return;box.querySelectorAll('[data-ikao-line-handle]').forEach(async line=>{const handle=line.dataset.ikaoLineHandle,raw=line.dataset.ikaoLineColor,base=line.dataset.ikaoLineTitleBase;if(!handle)return;const map=await fetchLabelMap(handle),currentTitle=await fetchProductTitle(handle),baseTitle=currentTitle||base||i18n.product,label=raw?colorLabelFromMap(map,raw):'',title=label?`${baseTitle} - ${label}`:baseTitle,titleEl=line.querySelector('[data-ikao-line-title]'),img=line.querySelector('[data-ikao-line-image]');line.dataset.ikaoLineTitleBase=baseTitle;if(titleEl)titleEl.textContent=title;if(img)img.alt=title})};
const renderWish=(a=readWish())=>{setCount('[data-ikao-wishlist-count]',a.length);if(wishBox){wishBox.innerHTML=a.length?a.map(wishLine).join(''):`<p class="ikao-cart-drawer__empty">${esc(i18n.emptyWishlist)}</p>`;hydrateLineLabels(wishBox)}};
const automaticDiscounts=cart=>{const apps=new Map(),put=(app,amount,cartLevel=false)=>{if(!app||String(app.type||'').toLowerCase()!=='automatic')return;const title=txt(app.title),key=txt(app.key)||title;if(!key)return;const current=apps.get(key)||{title,amount:0,cartLevel:false};if(title)current.title=title;if(cartLevel){current.amount=Number(app.total_allocated_amount??amount)||0;current.cartLevel=true}else if(!current.cartLevel)current.amount+=Number(amount)||0;apps.set(key,current)};(cart.cart_level_discount_applications||[]).forEach(app=>put(app,app.total_allocated_amount,true));(cart.items||[]).forEach(item=>(item.line_level_discount_allocations||[]).forEach(allocation=>put(allocation.discount_application,allocation.amount,false)));const values=[...apps.values()],names=[...new Set(values.map(app=>app.title).filter(Boolean))];return{names,amount:values.reduce((sum,app)=>sum+Math.max(app.amount||0,0),0)}};
const fetchProduct=async h=>{if(!h)return null;if(cache.has(h))return cache.get(h);const r=await fetch(url(`products/${h}.js`),{headers:{Accept:'application/json'}}),p=await r.json();cache.set(h,p);return p},idx=(p,test)=>(p?.options||[]).findIndex(o=>test(o.name||o)),vopt=(v,i)=>v?v[`option${i+1}`]:'',vals=(p,i)=>{const o=p?.options?.[i];if(o&&Array.isArray(o.values))return o.values;const s=new Set;(p?.variants||[]).forEach(v=>{const val=vopt(v,i);if(val)s.add(val)});return[...s]},colorMatches=(value,color,ctx)=>!txt(color)||txt(value)===txt(color)||localizedColor(value)===txt(color)||colorLabelFromMap(ctx?.labelMap,value)===txt(color),match=(p,size,ctx)=>{const si=idx(p,isSize),ci=idx(p,isColor);return(p?.variants||[]).find(v=>(si<0||txt(vopt(v,si))===txt(size))&&(ci<0||colorMatches(vopt(v,ci),ctx.color,ctx)))},vimg=(v,f)=>v?.featured_image?.src||f||'';
const openSheet=async ctx=>{if(!sheet||!sheetOptions||!ctx?.handle)return;pending=ctx;sheetOptions.innerHTML=`<p class="ikao-cart-drawer__empty">${esc(i18n.loading)}</p>`;sheet.classList.add('is-open');sheet.setAttribute('aria-hidden','false');try{const p=await fetchProduct(ctx.handle),labelMap=await fetchLabelMap(ctx.handle),si=idx(p,isSize),sizes=si>=0?vals(p,si):[];ctx.labelMap=labelMap;pending=ctx;sheetOptions.innerHTML=sizes.length?sizes.map(s=>{const v=match(p,s,ctx),d=!v||!v.available,sizeLabel=labelFromMap(labelMap,si,s)||String(s);return `<button class="ikao-cart-size-sheet__option" type="button" data-size-value="${esc(s)}"${d?' disabled':''}>${esc(String(sizeLabel).toUpperCase())}</button>`}).join(''):`<p class="ikao-cart-drawer__empty">${esc(i18n.noSizes)}</p>`}catch(e){sheetOptions.innerHTML=`<p class="ikao-cart-drawer__empty">${esc(i18n.sizeError)}</p>`}};
const changeQty=async(id,quantity)=>{await fetch(url('cart/change.js'),{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id,quantity})});await refresh(true,'cart')},changeVariant=async(item,v)=>{await fetch(url('cart/change.js'),{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})});await fetch(url('cart/add.js'),{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:item.quantity||1}]})});await refresh(true,'cart')};
const renderCart=cart=>{lastCart=cart;updateCartLinks(cart.item_count||0);const total=fmt(cart.total_price,cart.currency);if(cartTotal)cartTotal.textContent=total;if(cartCheckout)cartCheckout.textContent=`${i18n.checkout} - ${total}`;if(shipText&&shipBar){const rem=Math.max(freeLimit-cart.total_price,0),prog=Math.min(cart.total_price/freeLimit*100,100),unlocked=rem<=0,shipState=shipText.closest('[data-ikao-cart-shipping]');shipText.textContent=unlocked?`${i18n.freeShippingUnlocked} 😊`:`! ${String(i18n.freeShippingMore).replace('[amount]',fmt(rem,cart.currency))}`;if(shipState){shipState.classList.toggle('is-pending',!unlocked);shipState.classList.toggle('is-unlocked',unlocked)}shipBar.style.width=`${prog}%`}if(discountBox){const automatic=automaticDiscounts(cart),visible=automatic.names.length>0&&automatic.amount>0;discountBox.hidden=!visible;if(visible){if(discountName)discountName.textContent=automatic.names.join(' + ');if(discountOriginal)discountOriginal.textContent=fmt(cart.original_total_price??((cart.total_price||0)+automatic.amount),cart.currency);if(discountAmount)discountAmount.textContent=`- ${fmt(automatic.amount,cart.currency)}`}}if(cartBox){cartBox.innerHTML=!cart.items||!cart.items.length?`<p class="ikao-cart-drawer__empty">${esc(i18n.emptyCart)}</p>`:cart.items.map(cartLine).join('');hydrateLineLabels(cartBox)}};
const refresh=async(openAfter=false,m='cart')=>{if(req)req.abort();req=new AbortController;const r=await fetch(url('cart.js'),{headers:{Accept:'application/json'},signal:req.signal}),c=await r.json();renderCart(c);if(openAfter)open(m);return c};
const reqPath=r=>{const u=typeof r==='string'?r:r&&r.url;if(!u)return'';try{return new URL(u,location.origin).pathname}catch(e){return u}},watch=()=>{if(window.__ikaoCartFetchWatcherInstalled)return;const old=fetch;window.fetch=async(...a)=>{const p=reqPath(a[0]),mut=/\/cart\/(add|change|update|clear)(\.js)?$/.test(p),should=/\/cart\/add(\.js)?$/.test(p),res=await old(...a);if(res&&res.ok&&mut)setTimeout(()=>refresh(should).catch(()=>{}),90);return res};window.__ikaoCartFetchWatcherInstalled=true};
const pdpWish=()=>{const pdp=document.querySelector('[data-ikao-pdp]');if(!pdp)return null;let data={};try{data=JSON.parse(pdp.querySelector('[data-product-json]')?.textContent||'{}')}catch(e){}const variantId=Number(pdp.querySelector('[data-variant-input]')?.value||data.selected),variant=(data.variants||[]).find(v=>Number(v.id)===variantId)||{},path=location.pathname.split('/products/')[1]||'',handle=path.split('/')[0]||'',title=pdp.querySelector('.ikao-pdp__card-head h1,h1')?.textContent?.trim()||document.title,img=pdp.querySelector('[data-rail-slide]:not([hidden]) img,.ikao-pdp__hero img,img'),size=(pdp.querySelector('[data-selected-size-label]')?.textContent||'').split(':').pop().trim(),color=pdp.querySelector('[data-selected-color-label]')?.textContent?.trim()||'',priceText=pdp.querySelector('[data-price]')?.textContent?.trim()||'';return{id:String(variantId||handle),variantId,handle,title,url:handle?`/products/${handle}${variantId?`?variant=${variantId}`:''}`:location.pathname,image:img?.currentSrc||img?.src||'',price:variant.price||0,compare:variant.compare||0,priceText,size,color,quantity:1}};
const headerHeight=()=>{if(sticky)document.documentElement.style.setProperty('--ikao-lux-sticky-height',`${sticky.offsetHeight}px`)},scrollState=()=>{const y=scrollY,down=y>lastY&&y>20;document.body.classList.toggle('ikao-lux-scroll-down',down);document.body.classList.toggle('ikao-lux-scroll-up',!down&&y<lastY);lastY=y},closeMenus=()=>document.querySelectorAll('.ikao-lux-header__menu-item.is-submenu-open').forEach(i=>i.classList.remove('is-submenu-open')),hover=()=>document.querySelectorAll('.ikao-lux-header__menu-item').forEach(item=>{const sub=item.querySelector('.ikao-lux-header__submenu');if(!sub||item.dataset.ikaoHoverFixed==='true')return;let t;const o=()=>{clearTimeout(t);closeMenus();item.classList.add('is-submenu-open')},c=()=>{t=setTimeout(()=>item.classList.remove('is-submenu-open'),450)};item.addEventListener('pointerenter',o);item.addEventListener('pointerleave',c);sub.addEventListener('pointerenter',o);sub.addEventListener('pointerleave',c);item.dataset.ikaoHoverFixed='true'});
document.querySelectorAll('[data-ikao-cart-close]').forEach(b=>b.addEventListener('click',close));document.querySelectorAll('[data-ikao-cart-size-close]').forEach(b=>b.addEventListener('click',closeSheet));document.querySelectorAll('[data-ikao-drawer-tab]').forEach(b=>b.addEventListener('click',()=>setMode(b.dataset.ikaoDrawerTab)));
drawer?.addEventListener('click',async e=>{const so=e.target.closest('[data-ikao-size-open]');if(so){if(so.dataset.ikaoSizeOpen==='cart'){const item=lastCart?.items?.find(l=>l.key===so.dataset.lineKey);if(item)await openSheet({type:'cart',handle:item.handle,color:lineColor(item),size:lineSize(item),item})}else{const item=readWish().find(x=>String(x.id)===String(so.dataset.wishlistId));if(item)await openSheet({type:'wishlist',id:item.id,handle:item.handle,color:item.rawColor||item.color,size:item.size,item})}return}const q=e.target.closest('[data-ikao-qty-change]');if(q)return changeQty(q.dataset.lineKey,Number(q.dataset.qty));const rm=e.target.closest('[data-ikao-remove-line]');if(rm)return changeQty(rm.dataset.lineKey,0);const mv=e.target.closest('[data-ikao-move-wishlist]');if(mv){const item=lastCart?.items?.find(l=>l.key===mv.dataset.lineKey);if(item){addWish(toWish(item));await changeQty(item.key,0);open('wishlist')}return}const wq=e.target.closest('[data-ikao-wishlist-qty]');if(wq){saveWish(readWish().map(x=>String(x.id)===String(wq.dataset.wishlistId)?{...x,quantity:Math.max(Number(wq.dataset.qty)||1,1)}:x));return}const wr=e.target.closest('[data-ikao-wishlist-remove]');if(wr){saveWish(readWish().filter(x=>String(x.id)!==String(wr.dataset.wishlistId)));return}const wa=e.target.closest('[data-ikao-wishlist-add-cart]');if(wa){const item=readWish().find(x=>String(x.id)===String(wa.dataset.wishlistId));if(item?.variantId){await fetch(url('cart/add.js'),{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:item.variantId,quantity:item.quantity||1}]})});await refresh(true,'cart')}}});
sheetOptions?.addEventListener('click',async e=>{const b=e.target.closest('[data-size-value]');if(!b||b.disabled||!pending)return;const p=await fetchProduct(pending.handle),v=match(p,b.dataset.sizeValue,pending);if(!v||!v.available)return;if(pending.type==='cart')await changeVariant(pending.item,v);else{const si=idx(p,isSize),ci=idx(p,isColor),rawColor=ci>=0?vopt(v,ci):(pending.item.rawColor||pending.item.color);saveWish(readWish().map(x=>String(x.id)!==String(pending.id)?x:{...x,id:String(v.id),variantId:v.id,size:si>=0?vopt(v,si):x.size,color:rawColor?colorLabelFromMap(pending.labelMap,rawColor):x.color,rawColor:rawColor||x.rawColor,price:v.price,compare:v.compare_at_price||0,priceText:'',image:vimg(v,x.image),url:x.handle?`/products/${x.handle}?variant=${v.id}`:x.url}));open('wishlist')}closeSheet()});
document.addEventListener('click',e=>{const heart=e.target.closest('.ikao-pdp__wish');if(heart){e.preventDefault();const item=pdpWish();if(item){addWish(item);open('wishlist')}return}const a=e.target.closest('a');if(!a||a.closest('[data-ikao-cart-drawer]')||!cartLink(a))return;e.preventDefault();refresh(true,'cart').catch(()=>location.href=a.href)});
document.addEventListener('submit',async e=>{const f=e.target;if(!f||!f.matches('form[action*="/cart/add"]'))return;e.preventDefault();e.stopPropagation();const s=e.submitter;if(s)s.setAttribute('aria-busy','true');try{await fetch(url('cart/add.js'),{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)});await refresh(true,'cart')}catch(err){f.submit()}finally{if(s)s.removeAttribute('aria-busy')}},true);
['cart:updated','cart:update','cart:refresh','product:added'].forEach(n=>document.addEventListener(n,()=>refresh(n==='product:added','cart').catch(()=>{})));window.addEventListener('ikao:wishlist:add',e=>{addWish(e.detail);open('wishlist')});document.addEventListener('keyup',e=>{if(e.key==='Escape'){closeSheet();close();closeMenus()}});window.addEventListener('scroll',scrollState,{passive:true});window.addEventListener('resize',headerHeight);window.addEventListener('load',headerHeight,{once:true});watch();headerHeight();hover();renderWish();refresh(false).catch(()=>{});requestAnimationFrame(()=>{headerHeight();hover()});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-balenciaga-header"] && !Shopify.designMode) return;
  try {
    
  class IkaoLuxuryHeader extends HTMLElement {
    connectedCallback() {
      this.sticky = this.querySelector('[data-ikao-lux-sticky]');
      this.mobileMenu = this.querySelector('[data-ikao-mobile-menu]');
      this.closeButton = this.querySelector('[data-ikao-close-menu]');
      this.lastScrollY = window.scrollY;
      this.ticking = false;
      this.updateHeaderHeight();
      requestAnimationFrame(() => this.updateHeaderHeight());
      window.addEventListener('resize', this.updateHeaderHeight.bind(this));
      window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
      if (this.closeButton && this.mobileMenu) {
        this.closeButton.addEventListener('click', () => this.mobileMenu.removeAttribute('open'));
      }
      this.querySelectorAll('[data-ikao-localization-select]').forEach((select) => {
        select.addEventListener('change', () => {
          if (select.form) select.form.submit();
        });
      });
      document.addEventListener('click', (event) => {
        this.querySelectorAll('[data-ikao-localization]').forEach((details) => {
          if (!details.contains(event.target)) details.removeAttribute('open');
        });
      });
    }

    updateHeaderHeight() {
      if (!this.sticky) return;
      document.documentElement.style.setProperty('--ikao-lux-sticky-height', `${this.sticky.offsetHeight}px`);
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        if (currentScrollY > this.lastScrollY && currentScrollY > 120) {
          document.body.classList.add('ikao-lux-scroll-down');
          document.body.classList.remove('ikao-lux-scroll-up');
        } else {
          document.body.classList.add('ikao-lux-scroll-up');
          document.body.classList.remove('ikao-lux-scroll-down');
        }
        this.lastScrollY = currentScrollY;
        this.ticking = false;
      });
    }
  }

  if (!customElements.get('ikao-luxury-header')) {
    customElements.define('ikao-luxury-header', IkaoLuxuryHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-card-sheet-zindex-fix"]) return;
  try {
    
(() => {
  if (window.__ikaoCardSheetZindexFixInstalledV2) return;
  window.__ikaoCardSheetZindexFixInstalledV2 = true;

  const sync = () => {
    const isOpen = !!document.querySelector('.ikao-collection-mobile-sheet.is-open');
    document.documentElement.classList.toggle('ikao-collection-sheet-open', isOpen);
  };

  const boot = () => {
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
    document.addEventListener('click', () => window.setTimeout(sync, 30), true);
    document.addEventListener('keyup', () => window.setTimeout(sync, 30), true);
    window.addEventListener('resize', sync);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-lux-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
  const pageLang = (document.documentElement.lang || window.Shopify?.locale || '').toLowerCase();
  const copy = pageLang.startsWith('de') ? { selectedSize: 'AUSGEWÄHLTE GRÖSSE:', chooseSize: 'GRÖSSE AUSWÄHLEN' } : pageLang.startsWith('en') ? { selectedSize: 'SELECTED SIZE:', chooseSize: 'CHOOSE A SIZE' } : { selectedSize: 'TAILLE SÉLECTIONNÉE :', chooseSize: 'CHOISIR UNE TAILLE' };
  const opt = (v, i) => i === 0 ? v.option1 : i === 1 ? v.option2 : i === 2 ? v.option3 : '';
  document.querySelectorAll('[data-ikao-pdp]').forEach(root => {
    const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    const start = data.variants.find(v => v.id === data.selected) || data.variants.find(v => v.available) || data.variants[0];
    const state = { color: opt(start, data.colorIndex), size: opt(start, data.sizeIndex), variant: start };
    const q = s => root.querySelector(s);
    const qa = s => root.querySelectorAll(s);
    const variantInputs = qa('[data-variant-input]');
    const chart = q('[data-size-chart]');
    const sheet = q('[data-size-sheet]');
    const rail = q('[data-desktop-rail]');
    const sizeBlock = q('[data-desktop-size-block]');
    const sizeToggle = q('[data-size-toggle]');
    let railTimer = null;
    let railDirection = 1;
    let railStopped = false;
    const find = (color, size) => data.variants.find(v => (data.colorIndex < 0 || opt(v, data.colorIndex) === color) && (data.sizeIndex < 0 || opt(v, data.sizeIndex) === size));
    const firstSize = color => {
      const v = data.variants.find(item => (data.colorIndex < 0 || opt(item, data.colorIndex) === color) && item.available);
      return v ? opt(v, data.sizeIndex) : state.size;
    };
    const setMedia = id => {
      if (!id) return;
      const slider = q('[data-media-slider]');
      const slide = q(`[data-media-id="${id}"]`);
      if (slider && slide) slider.scrollTo({ top: slide.offsetTop, behavior: 'smooth' });
    };
    const stopRailAuto = () => {
      railStopped = true;
      if (railTimer) window.clearInterval(railTimer);
      railTimer = null;
    };
    const startRailAuto = direction => {
      if (!rail || railStopped) return;
      railDirection = direction || railDirection || 1;
      if (railTimer) window.clearInterval(railTimer);
      railTimer = window.setInterval(() => {
        if (!rail || rail.matches(':hover')) return;
        const max = rail.scrollWidth - rail.clientWidth;
        if (max <= 0) return;
        rail.scrollLeft += railDirection * 0.45;
        if (railDirection > 0 && rail.scrollLeft >= max - 2) rail.scrollLeft = 0;
        if (railDirection < 0 && rail.scrollLeft <= 2) rail.scrollLeft = max;
      }, 16);
    };
    const filterRail = direction => {
      if (!rail) return;
      const slides = Array.from(qa('[data-rail-slide]'));
      const selectedIndex = slides.findIndex(slide => slide.dataset.colorMedia && slide.dataset.colorMedia === state.color);
      const nextColorIndex = selectedIndex < 0 ? -1 : slides.findIndex((slide, index) => index > selectedIndex && slide.dataset.colorMedia);
      const shouldFilter = selectedIndex >= 0;
      slides.forEach((slide, index) => {
        if (!shouldFilter) {
          slide.hidden = false;
          return;
        }
        slide.hidden = index < selectedIndex || (nextColorIndex >= 0 && index >= nextColorIndex);
      });
      window.requestAnimationFrame(() => {
        const max = rail.scrollWidth - rail.clientWidth;
        rail.scrollLeft = direction < 0 ? Math.max(0, max) : 0;
        if (!railStopped) startRailAuto(direction || 1);
      });
    };
    const setPrice = v => {
      qa('[data-price],[data-mobile-price]').forEach(el => { el.textContent = money(v.price); });
      qa('[data-compare],[data-mobile-compare]').forEach(el => {
        el.hidden = !(v.compare && v.compare > v.price);
        el.textContent = v.compare && v.compare > v.price ? money(v.compare) : '';
      });
      const disc = q('[data-discount]');
      if (disc) {
        disc.hidden = !(v.compare && v.compare > v.price);
        disc.textContent = v.compare && v.compare > v.price ? `-${money(v.compare - v.price)}` : '';
      }
    };
    const syncVariantUrl = () => {
      if (!state.variant || !window.history?.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', state.variant.id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    };
    const refresh = () => {
      state.variant = find(state.color, state.size) || data.variants.find(v => (data.colorIndex < 0 || opt(v, data.colorIndex) === state.color) && v.available) || state.variant;
      if (!state.variant) return;
      state.size = opt(state.variant, data.sizeIndex) || state.size;
      variantInputs.forEach(input => { input.value = state.variant.id; input.dispatchEvent(new Event('change', { bubbles: true })); });
      setPrice(state.variant);
      syncVariantUrl();
      qa('[data-selected-color-label]').forEach(el => { el.textContent = state.color || ''; });
      qa('[data-selected-size-label]').forEach(el => { el.textContent = state.size ? `${copy.selectedSize} ${state.size.toUpperCase()}` : copy.chooseSize; });
      qa('[data-add-price]').forEach(el => { el.textContent = money(state.variant.price); });
      qa('[data-add],[data-mobile-add]').forEach(btn => { btn.disabled = !state.variant.available; });
      qa('[data-color]').forEach(btn => btn.classList.toggle('is-selected', btn.dataset.color === state.color));
      qa('[data-size]').forEach(btn => {
        if (!btn.dataset.size && data.sizeIndex >= 0) return;
        const possible = data.sizeIndex < 0 ? state.variant : find(state.color, btn.dataset.size);
        btn.classList.toggle('is-selected', btn.dataset.size === state.size);
        btn.classList.toggle('is-unavailable', !possible || !possible.available);
        btn.disabled = !possible || !possible.available;
      });
    };
    root.addEventListener('ikao:fit:select', event => {
      const detail = event.detail;
      if (!detail) return;
      const target = find(state.color, detail.size);
      if (!target?.available || String(target.id) !== String(detail.variantId)) return;
      state.size = detail.size;
      refresh();
      sizeBlock?.classList.remove('is-open');
      detail.accepted = true;
    });
    const addToCart = async id => {
      const body = new FormData();
      body.append('id', id);
      body.append('quantity', '1');
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`.replace(/\/{2,}/g, '/'), { method: 'POST', headers: { Accept: 'application/json' }, body });
      document.dispatchEvent(new CustomEvent('product:added'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('ikao:cart:refresh'));
    };
    qa('[data-color]').forEach(btn => btn.addEventListener('click', () => {
      if (btn.classList.contains('is-unavailable')) return;
      state.color = btn.dataset.color;
      if (!state.size) state.size = firstSize(state.color);
      refresh();
      filterRail(1);
      if (state.variant?.media) setMedia(state.variant.media);
    }));
    qa('[data-desktop-sizes] [data-size]').forEach(btn => btn.addEventListener('click', () => { if (!btn.disabled) { state.size = btn.dataset.size; refresh(); sizeBlock?.classList.remove('is-open'); } }));
    sizeToggle?.addEventListener('click', () => sizeBlock?.classList.toggle('is-open'));
    qa('[data-mobile-sizes] [data-size]').forEach(btn => btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      if (data.sizeIndex >= 0) state.size = btn.dataset.size;
      refresh();
      if (state.variant?.available) await addToCart(state.variant.id);
      sheet?.classList.remove('is-open');
      sheet?.setAttribute('aria-hidden', 'true');
    }));
    q('[data-add]')?.addEventListener('click', async () => {
      if (state.variant?.available) await addToCart(state.variant.id);
    });
    qa('form.ikao-pdp__form').forEach(form => form.addEventListener('submit', async e => {
      e.preventDefault();
      if (state.variant?.available) await addToCart(state.variant.id);
    }));
    qa('[data-media-trigger]').forEach(btn => btn.addEventListener('click', () => setMedia(btn.dataset.mediaTrigger)));
    const slider = q('[data-media-slider]');
    if (slider) slider.addEventListener('scroll', () => {
      const slides = Array.from(qa('[data-media-id]'));
      const active = slides.reduce((a, b) => Math.abs(b.offsetTop - slider.scrollTop) < Math.abs(a.offsetTop - slider.scrollTop) ? b : a, slides[0]);
      if (active) qa('[data-media-trigger]').forEach(btn => btn.classList.toggle('is-active', btn.dataset.mediaTrigger === active.dataset.mediaId));
    }, { passive: true });
    qa('[data-expand]').forEach(btn => btn.addEventListener('click', () => {
      const box = btn.closest('[data-expand-box]');
      box.classList.toggle('is-expanded');
      btn.textContent = box.classList.contains('is-expanded') ? 'Réduire' : 'Lire plus';
    }));
    qa('[data-tab]').forEach(btn => btn.addEventListener('click', () => {
      qa('[data-tab]').forEach(tab => tab.classList.toggle('is-active', tab === btn));
      qa('[data-pane]').forEach(pane => pane.classList.toggle('is-active', pane.dataset.pane === btn.dataset.tab));
    }));
    qa('[data-mobile-expand]').forEach(btn => btn.addEventListener('click', () => {
      const content = q('[data-mobile-desc]');
      content.classList.toggle('is-expanded');
      btn.textContent = content.classList.contains('is-expanded') ? 'Réduire' : 'Afficher plus';
    }));
    qa('[data-size-chart-open]').forEach(btn => btn.addEventListener('click', () => { chart?.classList.add('is-open'); chart?.setAttribute('aria-hidden', 'false'); }));
    qa('[data-size-chart-close]').forEach(btn => btn.addEventListener('click', () => { chart?.classList.remove('is-open'); chart?.setAttribute('aria-hidden', 'true'); }));
    q('[data-mobile-add]')?.addEventListener('click', async () => {
      if (data.sizeIndex < 0) return addToCart(state.variant.id);
      sheet?.classList.add('is-open');
      sheet?.setAttribute('aria-hidden', 'false');
    });
    qa('[data-size-sheet-close]').forEach(btn => btn.addEventListener('click', () => { sheet?.classList.remove('is-open'); sheet?.setAttribute('aria-hidden', 'true'); }));
    if (rail) {
      let dragging = false;
      let startX = 0;
      let startLeft = 0;
      rail.addEventListener('wheel', stopRailAuto, { passive: true });
      rail.addEventListener('pointerdown', event => {
        stopRailAuto();
        dragging = true;
        startX = event.clientX;
        startLeft = rail.scrollLeft;
        rail.classList.add('is-dragging');
        rail.setPointerCapture?.(event.pointerId);
      });
      rail.addEventListener('pointermove', event => {
        if (!dragging) return;
        event.preventDefault();
        rail.scrollLeft = startLeft - (event.clientX - startX);
      });
      const endDrag = () => {
        dragging = false;
        rail.classList.remove('is-dragging');
      };
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      filterRail(1);
      startRailAuto(1);
    }
    refresh();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-mobile-account-fix"]) return;
  try {
    
(() => {
  if (window.__ikaoMobileAccountFixInstalled) return;
  window.__ikaoMobileAccountFixInstalled = true;

  const normalize = value => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const isCampaign = value => {
    const text = normalize(value);
    if (text === 'promo' || text.startsWith('promo ') || text.includes('/collections/promo')) return true;
    return text.includes('2026') && (
      text.includes('soldes') ||
      text.includes('sale') ||
      text.includes('sales') ||
      text.includes('summer') ||
      text.includes('schlussverkauf') ||
      text.includes('promotion') ||
      text.includes('promo')
    );
  };

  const isCategory = value => {
    const text = normalize(value);
    if (!text || isCampaign(text)) return false;
    return text.includes('categor') || text.includes('vetement') || text.includes('clothing') || text.includes('clothes');
  };

  const directLink = (item, selector) => Array.from(item.children).find(child => child.matches?.(selector));

  const markCampaignLinks = () => {
    document.querySelectorAll('.ikao-lux-header__menu-item').forEach(item => {
      const link = directLink(item, '.ikao-lux-header__menu-link');
      if (!link || (!isCampaign(link.textContent) && !isCampaign(link.getAttribute('href')))) return;
      item.classList.add('is-campaign-sale');
      link.classList.add('ikao-lux-header__campaign-link');
      item.querySelectorAll('.ikao-lux-header__submenu-title,.ikao-lux-header__submenu-link').forEach(el => el.classList.add('ikao-lux-header__campaign-link'));
    });

    document.querySelectorAll('.ikao-lux-header__drawer-list > li').forEach(item => {
      const link = directLink(item, '.ikao-lux-header__drawer-link');
      if (!link || (!isCampaign(link.textContent) && !isCampaign(link.getAttribute('href')))) return;
      link.classList.add('ikao-lux-header__campaign-link');
      item.querySelectorAll('.ikao-lux-header__drawer-sublink').forEach(el => el.classList.add('ikao-lux-header__campaign-link'));
    });
  };

  const categoryLinksFromDesktop = () => {
    const items = Array.from(document.querySelectorAll('.ikao-lux-header__menu-item'));
    for (const item of items) {
      const link = directLink(item, '.ikao-lux-header__menu-link');
      const submenuLinks = Array.from(item.querySelectorAll('.ikao-lux-header__submenu-link'));
      if (link && submenuLinks.length && (isCategory(link.textContent) || isCategory(link.getAttribute('href')))) {
        return { title: link.textContent.trim(), links: submenuLinks };
      }
    }
    return null;
  };

  const categoryLinksFromDrawer = () => {
    const items = Array.from(document.querySelectorAll('.ikao-lux-header__drawer-list > li'));
    for (const item of items) {
      const link = directLink(item, '.ikao-lux-header__drawer-link');
      const sublinks = Array.from(item.querySelectorAll('.ikao-lux-header__drawer-sublink'));
      if (link && sublinks.length && (isCategory(link.textContent) || isCategory(link.getAttribute('href')))) {
        return { title: link.textContent.trim(), links: sublinks };
      }
    }
    return null;
  };

  const createMobileCategoryNav = () => {
    let nav = document.querySelector('.ikao-lux-mobile-cats-fix');
    if (nav && nav.querySelector('.ikao-lux-mobile-cats-fix__link')) return;

    const source = categoryLinksFromDesktop() || categoryLinksFromDrawer();
    if (!source || !source.links.length) return;

    if (!nav) {
      nav = document.createElement('nav');
      nav.className = 'ikao-lux-mobile-cats-fix';
      nav.dataset.ikaoJsCats = 'true';
      const headerFix = document.querySelector('.section-ikao-header-fix');
      const header = document.querySelector('[data-ikao-lux-header]')?.closest('.shopify-section') || document.querySelector('[data-ikao-lux-header]');
      if (headerFix) headerFix.appendChild(nav);
      else if (header) header.insertAdjacentElement('afterend', nav);
      else document.body.appendChild(nav);
    }

    nav.setAttribute('aria-label', source.title || 'Categories');
    nav.dataset.ikaoJsCats = 'true';
    nav.innerHTML = '<div class="ikao-lux-mobile-cats-fix__scroller"></div>';
    const scroller = nav.querySelector('.ikao-lux-mobile-cats-fix__scroller');

    source.links.forEach(oldLink => {
      const link = document.createElement('a');
      link.className = 'ikao-lux-mobile-cats-fix__link';
      link.href = oldLink.href;
      link.textContent = oldLink.textContent.trim();
      if (oldLink.classList.contains('is-active')) link.classList.add('is-active');
      if (isCampaign(source.title)) link.classList.add('ikao-lux-header__campaign-link');
      scroller.appendChild(link);
    });
  };

  const insertMobileAccount = () => {
    const template = document.querySelector('[data-ikao-mobile-account-template]');
    const drawer = document.querySelector('.ikao-lux-header__drawer');
    if (!template || !drawer || drawer.querySelector('.ikao-lux-header__mobile-account-link')) return;

    const link = template.content.firstElementChild.cloneNode(true);
    const nav = drawer.querySelector('nav');
    if (nav) drawer.insertBefore(link, nav);
    else drawer.appendChild(link);
  };

  const syncEuOverlayFront = () => {
    const overlay = document.getElementById('eu-only-overlay');
    const isActive =
      document.documentElement.classList.contains('eu-overlay-active') ||
      document.body?.classList.contains('eu-overlay-active') ||
      overlay?.style?.display === 'flex';

    document.documentElement.classList.toggle('eu-overlay-front', !!isActive);
    if (document.body) document.body.classList.toggle('eu-overlay-front', !!isActive);

    if (!overlay || !isActive) return;
    overlay.style.setProperty('z-index', '2147483647', 'important');
    overlay.style.setProperty('position', 'fixed', 'important');
    overlay.style.setProperty('inset', '0', 'important');
    overlay.style.setProperty('display', 'flex', 'important');
    overlay.style.setProperty('pointer-events', 'auto', 'important');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('tabindex', '-1');
  };

  const run = () => {
    insertMobileAccount();
    markCampaignLinks();
    createMobileCategoryNav();
    syncEuOverlayFront();
  };

  let raf = 0;
  const scheduleRun = () => {
    if (raf) return;
    raf = window.requestAnimationFrame(() => {
      raf = 0;
      run();
    });
  };

  const boot = () => {
    run();
    const root = document.querySelector('[data-ikao-lux-header]') || document.body;
    new MutationObserver(scheduleRun).observe(root, { childList: true, subtree: true });
    new MutationObserver(scheduleRun).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (document.body) {
      new MutationObserver(scheduleRun).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'], childList: true });
    }
    window.setTimeout(run, 250);
    window.setTimeout(run, 900);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-mobile-add-availability-fix"]) return;
  try {
    
(() => {
  const opt = (variant, index) => index === 0 ? variant.option1 : index === 1 ? variant.option2 : index === 2 ? variant.option3 : '';

  const readData = root => {
    try {
      return JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
    } catch (error) {
      return null;
    }
  };

  const selectedColor = (root, data) => {
    const selected = root.querySelector('[data-color].is-selected');
    if (selected?.dataset.color) return selected.dataset.color;
    const current = data?.variants?.find(variant => variant.id === data.selected) || data?.variants?.[0];
    return current && data.colorIndex >= 0 ? opt(current, data.colorIndex) : '';
  };

  const selectedColorHasAvailableSize = (root, data) => {
    if (!data?.variants?.length) return false;
    const color = selectedColor(root, data);
    return data.variants.some(variant => {
      const colorMatches = data.colorIndex < 0 || opt(variant, data.colorIndex) === color;
      return colorMatches && variant.available;
    });
  };

  const syncRoot = root => {
    if (!root) return;
    const data = readData(root);
    const mobileAdd = root.querySelector('[data-mobile-add]');
    if (!data || !mobileAdd) return;

    const hasAvailableSize = selectedColorHasAvailableSize(root, data);
    mobileAdd.disabled = !hasAvailableSize;
    mobileAdd.classList.toggle('is-unavailable-color', !hasAvailableSize);
  };

  const scheduleSync = root => {
    if (!root) return;
    window.requestAnimationFrame(() => syncRoot(root));
    window.setTimeout(() => syncRoot(root), 80);
    window.setTimeout(() => syncRoot(root), 220);
  };

  const initRoot = root => {
    if (!root || root.dataset.ikaoMobileAddAvailabilityFix === 'true') return;
    root.dataset.ikaoMobileAddAvailabilityFix = 'true';
    const watchTarget = root.querySelector('.ikao-pdp__bar') || root;
    new MutationObserver(() => scheduleSync(root)).observe(watchTarget, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'hidden']
    });
    scheduleSync(root);
  };

  const run = () => document.querySelectorAll('[data-ikao-pdp]').forEach(initRoot);

  document.addEventListener('click', event => {
    const control = event.target.closest?.('[data-color], [data-size]');
    if (!control) return;
    scheduleSync(control.closest('[data-ikao-pdp]'));
  }, true);

  document.addEventListener('change', event => scheduleSync(event.target.closest?.('[data-ikao-pdp]')), true);
  document.addEventListener('cart:refresh', run);
  window.addEventListener('pageshow', run);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-mobile-pdp-enhancer"]) return;
  try {
    
(() => {
  const syncCartCheckoutTotal = () => {
    const total = document.querySelector('[data-ikao-cart-total]');
    const checkout = document.querySelector('.ikao-cart-drawer__checkout');
    if (!total || !checkout) return;
    const amount = total.textContent.trim();
    checkout.textContent = amount ? `Finaliser la commande - ${amount}` : 'Finaliser la commande';
  };

  const initCartTotalSync = () => {
    const total = document.querySelector('[data-ikao-cart-total]');
    const drawer = document.querySelector('[data-ikao-cart-drawer]');
    if (!total || total.dataset.ikaoCheckoutSync === 'true') return;
    total.dataset.ikaoCheckoutSync = 'true';
    new MutationObserver(syncCartCheckoutTotal).observe(total, { childList: true, characterData: true, subtree: true });
    if (drawer) new MutationObserver(syncCartCheckoutTotal).observe(drawer, { attributes: true, attributeFilter: ['class', 'data-ikao-cart-mode'] });
    document.addEventListener('cart:refresh', syncCartCheckoutTotal);
    window.addEventListener('ikao:cart:refresh', () => window.setTimeout(syncCartCheckoutTotal, 350));
    syncCartCheckoutTotal();
  };

  const enhance = root => {
    if (!root || root.dataset.ikaoMobileEnhanced === 'true') return;
    root.dataset.ikaoMobileEnhanced = 'true';

    const mobile = root.querySelector('.ikao-pdp__mobile');
    const tabs = root.querySelector('.ikao-pdp__tabs');
    const railSlides = Array.from(root.querySelectorAll('[data-rail-slide]'));
    if (!mobile || !tabs || !railSlides.length) return;

    let slider = root.querySelector('[data-mobile-media-slider]');
    let track = root.querySelector('.ikao-pdp__mobile-track');
    let dots = root.querySelector('.ikao-pdp__mobile-dots');

    if (!slider) {
      slider = document.createElement('div');
      slider.className = 'ikao-pdp__mobile-slider';
      slider.dataset.mobileMediaSlider = '';
      slider.setAttribute('aria-label', 'Images du produit');

      const wish = document.createElement('button');
      wish.type = 'button';
      wish.className = 'ikao-pdp__mobile-wish ikao-pdp__wish';
      wish.setAttribute('aria-label', 'Ajouter aux favoris');
      wish.textContent = '♡';

      track = document.createElement('div');
      track.className = 'ikao-pdp__mobile-track';

      dots = document.createElement('div');
      dots.className = 'ikao-pdp__mobile-dots';
      dots.setAttribute('aria-hidden', 'true');

      railSlides.forEach((railSlide, index) => {
        const media = railSlide.firstElementChild;
        if (!media) return;

        const slide = document.createElement('div');
        slide.className = 'ikao-pdp__mobile-slide';
        slide.dataset.mobileSlide = '';
        slide.dataset.mediaId = railSlide.dataset.mediaId || String(index);
        slide.dataset.colorMedia = railSlide.dataset.colorMedia || '';
        slide.appendChild(media.cloneNode(true));
        track.appendChild(slide);

        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.mobileDot = '';
        dot.dataset.mediaTrigger = slide.dataset.mediaId;
        dot.setAttribute('aria-label', `Image ${index + 1}`);
        dots.appendChild(dot);
      });

      slider.append(wish, track, dots);
      mobile.insertBefore(slider, tabs);
    }

    const legacyHero = root.querySelector('.ikao-pdp__hero');
    const legacyStack = root.querySelector('.ikao-pdp__stack');
    if (legacyHero) legacyHero.hidden = true;
    if (legacyStack) legacyStack.hidden = true;

    const colors = root.querySelector('.ikao-pdp__bar-colors');
    if (colors && !colors.closest('.ikao-pdp__bar-color-wrap')) {
      const wrap = document.createElement('div');
      wrap.className = 'ikao-pdp__bar-color-wrap';
      colors.parentNode.insertBefore(wrap, colors);
      wrap.appendChild(colors);
    }

    const getSelectedColor = () => {
      const selected = root.querySelector('[data-color].is-selected');
      return selected ? selected.dataset.color : '';
    };

    const updateStickyInfo = () => {
      const title = root.querySelector('.ikao-pdp__bar-row strong');
      if (title) {
        if (!title.dataset.ikaoBaseTitle) {
          const cardTitle = root.querySelector('.ikao-pdp__card-head h1');
          title.dataset.ikaoBaseTitle = (cardTitle?.textContent || title.textContent.split(' - ')[0] || '').trim();
        }
        const nextTitle = getSelectedColor() ? `${title.dataset.ikaoBaseTitle} - ${getSelectedColor()}` : title.dataset.ikaoBaseTitle;
        if (title.textContent !== nextTitle) title.textContent = nextTitle;
      }

      const compare = root.querySelector('[data-mobile-compare]');
      const price = root.querySelector('[data-mobile-price]');
      if (compare && price) price.classList.toggle('is-sale', !compare.hidden && compare.textContent.trim() !== '');
    };

    const updateDots = () => {
      const visibleSlides = Array.from(root.querySelectorAll('[data-mobile-slide]')).filter(slide => !slide.hidden);
      if (!track || !visibleSlides.length) return;
      const active = visibleSlides.reduce((best, slide) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(best.offsetLeft - track.scrollLeft) ? slide : best, visibleSlides[0]);
      root.querySelectorAll('[data-mobile-dot]').forEach(dot => dot.classList.toggle('is-active', dot.dataset.mediaTrigger === active.dataset.mediaId));
    };

    const filterMobileMedia = () => {
      const selectedColor = getSelectedColor();
      const slides = Array.from(root.querySelectorAll('[data-mobile-slide]'));
      const dotButtons = Array.from(root.querySelectorAll('[data-mobile-dot]'));
      const selectedIndex = slides.findIndex(slide => slide.dataset.colorMedia && slide.dataset.colorMedia === selectedColor);
      const nextColorIndex = selectedIndex < 0 ? -1 : slides.findIndex((slide, index) => index > selectedIndex && slide.dataset.colorMedia);
      const shouldFilter = selectedIndex >= 0;

      slides.forEach((slide, index) => {
        const hidden = shouldFilter && (index < selectedIndex || (nextColorIndex >= 0 && index >= nextColorIndex));
        slide.hidden = hidden;
        if (dotButtons[index]) dotButtons[index].hidden = hidden;
      });

      window.requestAnimationFrame(() => {
        if (track) track.scrollLeft = 0;
        updateDots();
      });
    };

    root.querySelectorAll('[data-mobile-dot]').forEach(dot => {
      dot.addEventListener('click', () => {
        const slide = root.querySelector(`[data-mobile-slide][data-media-id="${dot.dataset.mediaTrigger}"]`);
        if (track && slide && !slide.hidden) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });

    track?.addEventListener('scroll', updateDots, { passive: true });
    root.querySelectorAll('[data-color]').forEach(button => {
      button.addEventListener('click', () => window.setTimeout(() => {
        filterMobileMedia();
        updateStickyInfo();
      }, 0));
    });
    root.querySelectorAll('[data-size]').forEach(button => {
      button.addEventListener('click', () => window.setTimeout(updateStickyInfo, 0));
    });

    filterMobileMedia();
    updateStickyInfo();
  };

  const run = () => {
    const productRoots = document.querySelectorAll('[data-ikao-pdp]');
    if (productRoots.length) document.documentElement.classList.add('ikao-product-page');
    productRoots.forEach(enhance);
    initCartTotalSync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-mobile-size-sheet-fix"]) return;
  try {
    
(() => {
  if (window.__ikaoMobileSizePortalInstalled) return;
  window.__ikaoMobileSizePortalInstalled = true;

  const mq = window.matchMedia('(max-width: 989px)');
  const portal = document.querySelector('[data-ikao-mobile-size-portal]');
  const optionsBox = document.querySelector('[data-ikao-mobile-size-options]');
  const meta = document.querySelector('[data-ikao-mobile-size-meta]');
  let pendingRoot = null;
  let pendingData = null;

  const opt = (variant, index) => index === 0 ? variant.option1 : index === 1 ? variant.option2 : index === 2 ? variant.option3 : '';
  const clean = value => String(value || '').trim();
  const lower = value => clean(value).toLowerCase();
  const esc = value => String(value || '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));

  const readData = root => {
    try {
      return JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
    } catch (error) {
      return null;
    }
  };

  const selectedColor = (root, data) => {
    const selected = Array.from(root.querySelectorAll('[data-color].is-selected')).find(button => button.dataset.color);
    if (selected?.dataset.color) return clean(selected.dataset.color);
    const label = root.querySelector('[data-selected-color-label]');
    if (label?.textContent) return clean(label.textContent);
    const inputId = Number(root.querySelector('[data-variant-input]')?.value || data?.selected || 0);
    const current = data?.variants?.find(variant => Number(variant.id) === inputId) || data?.variants?.[0];
    return current && data?.colorIndex >= 0 ? clean(opt(current, data.colorIndex)) : '';
  };

  const allSizes = data => {
    if (!data?.variants?.length || data.sizeIndex < 0) return [];
    const sizes = [];
    data.variants.forEach(variant => {
      const size = clean(opt(variant, data.sizeIndex));
      if (size && !sizes.some(item => lower(item) === lower(size))) sizes.push(size);
    });
    return sizes;
  };

  const variantFor = (data, color, size) => data?.variants?.find(variant => {
    const colorMatches = data.colorIndex < 0 || lower(opt(variant, data.colorIndex)) === lower(color);
    const sizeMatches = data.sizeIndex < 0 || !size || lower(opt(variant, data.sizeIndex)) === lower(size);
    return colorMatches && sizeMatches;
  }) || null;

  const firstAvailableForColor = (data, color) => data?.variants?.find(variant => {
    const colorMatches = data.colorIndex < 0 || lower(opt(variant, data.colorIndex)) === lower(color);
    return colorMatches && variant.available;
  }) || null;

  const colorHasStock = (root) => {
    const data = readData(root);
    if (!data?.variants?.length) return false;
    const color = selectedColor(root, data);
    return !!firstAvailableForColor(data, color);
  };

  const syncMobileAdd = root => {
    if (!root) return;
    const button = root.querySelector('[data-mobile-add]');
    if (!button) return;
    button.disabled = !colorHasStock(root);
  };

  const addToCart = async variantId => {
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`.replace(/\/{2,}/g, '/'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body
    });
    document.dispatchEvent(new CustomEvent('product:added'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.dispatchEvent(new CustomEvent('ikao:cart:refresh'));
  };

  const closePortal = () => {
    pendingRoot = null;
    pendingData = null;
    portal?.classList.remove('is-open');
    portal?.setAttribute('aria-hidden', 'true');
  };

  const openPortal = root => {
    if (!portal || !optionsBox) return;
    const data = readData(root);
    if (!data?.variants?.length) return;
    const color = selectedColor(root, data);
    const sizes = allSizes(data);
    pendingRoot = root;
    pendingData = data;

    if (meta) meta.textContent = color ? `Couleur sélectionnée : ${color}` : '';

    if (!sizes.length) {
      const variant = firstAvailableForColor(data, color) || variantFor(data, color, '');
      if (variant?.available) addToCart(variant.id);
      return;
    }

    optionsBox.innerHTML = sizes.map(size => {
      const variant = variantFor(data, color, size);
      const disabled = !variant || !variant.available;
      return `<button class="ikao-mobile-size-portal__option" type="button" data-ikao-mobile-size-value="${esc(size)}"${disabled ? ' disabled' : ''}>${esc(size.toUpperCase())}</button>`;
    }).join('');

    let helper = portal.querySelector('.ikao-fit-panel-link');
    let hint = portal.querySelector('.ikao-fit-panel-hint');
    if (!helper && window.IKAOSizeFinder && sizes.length > 1) {
      helper = document.createElement('button');
      helper.type = 'button';
      helper.className = 'ikao-fit-panel-link';
      hint = document.createElement('p');
      hint.className = 'ikao-fit-panel-hint';
      hint.setAttribute('role', 'status');
      optionsBox.insertAdjacentElement('afterend', hint);
      optionsBox.insertAdjacentElement('afterend', helper);
    }
    if (helper) {
      const fitCopy = window.IKAOSizeFinder.copy();
      helper.textContent = `${fitCopy.open} ↗`;
      helper.hidden = sizes.length < 2;
      hint.textContent = '';
      helper.onclick = event => {
        event.preventDefault();
        event.stopPropagation();
        root.dispatchEvent(new CustomEvent('ikao:fit:open', { detail: {
          opener: helper,
          onSelect: size => {
            if (pendingRoot !== root) return;
            optionsBox.querySelectorAll('[data-ikao-mobile-size-value]').forEach(b => b.classList.toggle('is-ikao-fit-recommended', b.dataset.ikaoMobileSizeValue === size));
            hint.textContent = fitCopy.panelHint.replace('[size]', size);
          }
        }}));
      };
    }

    portal.classList.add('is-open');
    portal.setAttribute('aria-hidden', 'false');
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-mobile-add]');
    if (!button || !mq.matches) return;
    const root = button.closest('[data-ikao-pdp]');
    if (!root) return;

    syncMobileAdd(root);
    if (button.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openPortal(root);
  }, true);

  optionsBox?.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-ikao-mobile-size-value]');
    if (!button || button.disabled || !pendingRoot || !pendingData) return;
    const color = selectedColor(pendingRoot, pendingData);
    const variant = variantFor(pendingData, color, button.dataset.ikaoMobileSizeValue);
    if (!variant || !variant.available) return;
    await addToCart(variant.id);
    closePortal();
  });

  document.querySelectorAll('[data-ikao-mobile-size-close]').forEach(button => button.addEventListener('click', closePortal));
  document.addEventListener('keyup', event => { if (event.key === 'Escape') closePortal(); });

  const run = () => document.querySelectorAll('[data-ikao-pdp]').forEach(root => {
    syncMobileAdd(root);
    root.querySelectorAll('[data-color]').forEach(button => {
      if (button.dataset.ikaoMobileSizeSync === 'true') return;
      button.dataset.ikaoMobileSizeSync = 'true';
      button.addEventListener('click', () => window.setTimeout(() => syncMobileAdd(root), 0));
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-mobile-wishlist-size-fix"]) return;
  try {
    
(() => {
  if (window.__ikaoWishlistVariantFixInstalledV2) return;
  window.__ikaoWishlistVariantFixInstalledV2 = true;

  const mq = window.matchMedia('(max-width: 989px)');
  const sheet = document.querySelector('[data-ikao-wishlist-size-sheet]');
  const optionsBox = document.querySelector('[data-ikao-wishlist-size-options]');
  const colorLabel = document.querySelector('[data-ikao-wishlist-size-color]');
  let pendingRoot = null;
  let pendingData = null;

  const opt = (variant, index) => index === 0 ? variant.option1 : index === 1 ? variant.option2 : index === 2 ? variant.option3 : '';
  const clean = value => String(value || '').trim();
  const lower = value => clean(value).toLowerCase();
  const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
  const esc = value => String(value || '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const isVisible = element => !!(element && element.getClientRects && element.getClientRects().length && window.getComputedStyle(element).display !== 'none' && window.getComputedStyle(element).visibility !== 'hidden');

  const readData = root => {
    try {
      return JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
    } catch (error) {
      return null;
    }
  };

  const currentVariantFromInput = (root, data) => {
    const visibleInput = Array.from(root.querySelectorAll('[data-variant-input]')).find(input => isVisible(input.closest('form')) || input.closest('.ikao-pdp__floating-card'));
    const id = Number(visibleInput?.value || root.querySelector('[data-variant-input]')?.value || data?.selected || 0);
    return data?.variants?.find(variant => Number(variant.id) === id) || data?.variants?.find(variant => Number(variant.id) === Number(data?.selected)) || data?.variants?.[0] || null;
  };

  const selectedColor = (root, data) => {
    const selectedButtons = Array.from(root.querySelectorAll('[data-color].is-selected'));
    const visibleSelected = selectedButtons.find(isVisible);
    if (visibleSelected?.dataset.color) return clean(visibleSelected.dataset.color);
    const anySelected = selectedButtons.find(button => button.dataset.color);
    if (anySelected?.dataset.color) return clean(anySelected.dataset.color);
    const label = root.querySelector('[data-selected-color-label]');
    if (label?.textContent) return clean(label.textContent);
    const current = currentVariantFromInput(root, data);
    return current && data?.colorIndex >= 0 ? clean(opt(current, data.colorIndex)) : '';
  };

  const selectedSize = (root, data) => {
    const selectedButtons = Array.from(root.querySelectorAll('[data-size].is-selected'));
    const visibleSelected = selectedButtons.find(isVisible);
    if (visibleSelected?.dataset.size) return clean(visibleSelected.dataset.size);
    const anySelected = selectedButtons.find(button => button.dataset.size);
    if (anySelected?.dataset.size) return clean(anySelected.dataset.size);
    const label = root.querySelector('[data-selected-size-label]');
    if (label?.textContent && label.textContent.includes(':')) return clean(label.textContent.split(':').pop());
    const current = currentVariantFromInput(root, data);
    return current && data?.sizeIndex >= 0 ? clean(opt(current, data.sizeIndex)) : '';
  };

  const currentHandle = () => {
    const path = window.location.pathname.split('/products/')[1] || '';
    return path.split('/')[0] || '';
  };

  const productTitle = root => clean(root.querySelector('.ikao-pdp__card-head h1, h1')?.textContent || document.title);

  const imageFor = (root, variant) => {
    const byMedia = variant?.media ? root.querySelector(`[data-mobile-slide][data-media-id="${variant.media}"] img, [data-rail-slide][data-media-id="${variant.media}"] img`) : null;
    const visibleColorMedia = root.querySelector('[data-mobile-slide]:not([hidden]) img, [data-rail-slide]:not([hidden]) img');
    const selectedColorImage = root.querySelector('[data-color].is-selected img');
    const image = byMedia || visibleColorMedia || selectedColorImage || root.querySelector('img');
    return image?.currentSrc || image?.src || '';
  };

  const uniqueSizes = data => {
    if (!data?.variants?.length || data.sizeIndex < 0) return [];
    const sizes = [];
    data.variants.forEach(variant => {
      const size = clean(opt(variant, data.sizeIndex));
      if (size && !sizes.some(item => lower(item) === lower(size))) sizes.push(size);
    });
    return sizes;
  };

  const variantFor = (data, color, size) => {
    if (!data?.variants?.length) return null;
    return data.variants.find(variant => {
      const colorMatches = data.colorIndex < 0 || lower(opt(variant, data.colorIndex)) === lower(color);
      const sizeMatches = data.sizeIndex < 0 || !size || lower(opt(variant, data.sizeIndex)) === lower(size);
      return colorMatches && sizeMatches;
    }) || null;
  };

  const firstAvailableForColor = (data, color) => data?.variants?.find(variant => {
    const colorMatches = data.colorIndex < 0 || lower(opt(variant, data.colorIndex)) === lower(color);
    return colorMatches && variant.available;
  }) || null;

  const closeSheet = () => {
    pendingRoot = null;
    pendingData = null;
    sheet?.classList.remove('is-open');
    sheet?.setAttribute('aria-hidden', 'true');
  };

  const addWishlistVariant = (root, data, variant) => {
    if (!variant) return;
    const handle = currentHandle();
    const color = data.colorIndex >= 0 ? clean(opt(variant, data.colorIndex)) : selectedColor(root, data);
    const size = data.sizeIndex >= 0 ? clean(opt(variant, data.sizeIndex)) : '';
    const item = {
      id: String(variant.id),
      variantId: variant.id,
      handle,
      title: productTitle(root),
      url: handle ? `/products/${handle}?variant=${variant.id}` : window.location.pathname,
      image: imageFor(root, variant),
      price: variant.price || 0,
      compare: variant.compare || 0,
      priceText: money(variant.price || 0),
      size,
      color,
      quantity: 1
    };
    window.dispatchEvent(new CustomEvent('ikao:wishlist:add', { detail: item }));
  };

  const openMobileSheet = root => {
    if (!sheet || !optionsBox) return;
    const data = readData(root);
    if (!data?.variants?.length) return;

    const color = selectedColor(root, data);
    const sizes = uniqueSizes(data);
    pendingRoot = root;
    pendingData = data;

    if (colorLabel) colorLabel.textContent = color ? `Couleur sélectionnée : ${color}` : '';

    if (!sizes.length) {
      const variant = firstAvailableForColor(data, color) || variantFor(data, color, '');
      if (variant?.available) addWishlistVariant(root, data, variant);
      return;
    }

    optionsBox.innerHTML = sizes.map(size => {
      const variant = variantFor(data, color, size);
      const disabled = !variant || !variant.available;
      return `<button class="ikao-wishlist-size-sheet__option" type="button" data-ikao-wishlist-size-value="${esc(size)}"${disabled ? ' disabled' : ''}>${esc(size.toUpperCase())}</button>`;
    }).join('');

    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
  };

  const addDesktopSelection = root => {
    const data = readData(root);
    if (!data?.variants?.length) return;
    const color = selectedColor(root, data);
    const size = selectedSize(root, data);
    const exact = variantFor(data, color, size);
    const variant = exact?.available ? exact : firstAvailableForColor(data, color) || exact;
    if (variant) addWishlistVariant(root, data, variant);
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('.ikao-pdp__wish');
    if (!button) return;
    const root = button.closest('[data-ikao-pdp]');
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (mq.matches) openMobileSheet(root);
    else addDesktopSelection(root);
  }, true);

  optionsBox?.addEventListener('click', event => {
    const button = event.target.closest?.('[data-ikao-wishlist-size-value]');
    if (!button || button.disabled || !pendingRoot || !pendingData) return;
    const color = selectedColor(pendingRoot, pendingData);
    const variant = variantFor(pendingData, color, button.dataset.ikaoWishlistSizeValue);
    if (!variant || !variant.available) return;
    addWishlistVariant(pendingRoot, pendingData, variant);
    closeSheet();
  });

  document.querySelectorAll('[data-ikao-wishlist-size-close]').forEach(button => button.addEventListener('click', closeSheet));
  document.addEventListener('keyup', event => { if (event.key === 'Escape') closeSheet(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-pdp-sale-price-fix"]) return;
  try {
    
(() => {
  if (window.__ikaoPdpSalePriceFixInstalledV3) return;
  window.__ikaoPdpSalePriceFixInstalledV3 = true;

  const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format((Number(cents) || 0) / 100);
  const opt = (variant, index) => index === 0 ? variant.option1 : index === 1 ? variant.option2 : index === 2 ? variant.option3 : '';
  const clean = value => String(value || '').trim();

  const readData = root => {
    try {
      return JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
    } catch (error) {
      return null;
    }
  };

  const currentVariant = (root, data) => {
    if (!data?.variants?.length) return null;
    const inputId = Number(root.querySelector('.ikao-pdp__floating-card [data-variant-input]')?.value || root.querySelector('[data-variant-input]')?.value || data.selected || 0);
    const fromInput = data.variants.find(variant => Number(variant.id) === inputId);
    if (fromInput) return fromInput;

    const color = clean(root.querySelector('[data-color].is-selected')?.dataset.color || root.querySelector('[data-selected-color-label]')?.textContent || '');
    const sizeButton = root.querySelector('[data-desktop-sizes] [data-size].is-selected') || root.querySelector('[data-size].is-selected');
    const size = clean(sizeButton?.dataset.size || root.querySelector('[data-selected-size-label]')?.textContent?.split(':').pop() || '');

    return data.variants.find(variant => {
      const colorMatches = data.colorIndex < 0 || !color || clean(opt(variant, data.colorIndex)) === color;
      const sizeMatches = data.sizeIndex < 0 || !size || clean(opt(variant, data.sizeIndex)).toLowerCase() === size.toLowerCase();
      return colorMatches && sizeMatches;
    }) || data.variants.find(variant => Number(variant.id) === Number(data.selected)) || data.variants[0];
  };

  const formatFromDom = (root, cents) => {
    const sample = clean(root.querySelector('[data-price]')?.textContent || '');
    const value = (Number(cents) || 0) / 100;
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents);
    } catch (error) {}
    if (sample.includes('$')) return `$${value.toFixed(2)}`;
    if (sample.includes('£')) return `£${value.toFixed(2)}`;
    if (sample.includes('₺') || sample.includes('TL')) return `${value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`;
    return money(cents);
  };

  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  const syncRoot = root => {
    const data = readData(root);
    const variant = currentVariant(root, data);
    const priceBox = root.querySelector('.ikao-pdp__floating-card .ikao-pdp__price');
    if (!data || !variant || !priceBox) return;

    const key = `${variant.id}-${variant.price}-${variant.compare || 0}`;
    if (priceBox.dataset.ikaoSaleKey === key) return;
    priceBox.dataset.ikaoSaleKey = key;

    const price = Number(variant.price || 0);
    const compare = Number(variant.compare || 0);
    let line = priceBox.querySelector('.ikao-pdp-sale-line');

    if (!compare || !price || compare <= price) {
      priceBox.classList.remove('has-ikao-pdp-sale');
      line?.remove();
      return;
    }

    const percent = Math.max(1, Math.round(((compare - price) / compare) * 100));
    if (!line) {
      line = document.createElement('span');
      line.className = 'ikao-pdp-sale-line';
      line.innerHTML = '<span class="ikao-pdp-sale-line__compare"></span><span class="ikao-pdp-sale-line__percent"></span><span class="ikao-pdp-sale-line__price"></span>';
      priceBox.appendChild(line);
    }

    setText(line.querySelector('.ikao-pdp-sale-line__compare'), formatFromDom(root, compare));
    setText(line.querySelector('.ikao-pdp-sale-line__percent'), `-${percent}%`);
    setText(line.querySelector('.ikao-pdp-sale-line__price'), formatFromDom(root, price));
    priceBox.classList.add('has-ikao-pdp-sale');
  };

  const scheduleSync = root => {
    if (!root || root.dataset.ikaoPdpSaleRaf === 'true') return;
    root.dataset.ikaoPdpSaleRaf = 'true';
    window.requestAnimationFrame(() => {
      root.dataset.ikaoPdpSaleRaf = 'false';
      syncRoot(root);
    });
  };

  const initRoot = root => {
    if (!root || root.dataset.ikaoPdpSalePriceFixV3 === 'true') return;
    root.dataset.ikaoPdpSalePriceFixV3 = 'true';
    scheduleSync(root);

    root.addEventListener('click', event => {
      if (event.target.closest('[data-color], [data-size]')) scheduleSync(root);
    }, true);

    root.addEventListener('change', event => {
      if (event.target.matches('[data-variant-input]')) scheduleSync(root);
    }, true);
  };

  const run = () => document.querySelectorAll('[data-ikao-pdp]').forEach(initRoot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-pdp-sku-fix"]) return;
  try {
    
(() => {
  if (window.__ikaoPdpSkuFixInstalled) return;
  window.__ikaoPdpSkuFixInstalled = true;

  const readMap = root => {
    try {
      const script = root.parentElement?.querySelector('[data-ikao-pdp-sku-map]') || document.querySelector('[data-ikao-pdp-sku-map]');
      return JSON.parse(script?.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const targetFor = root => {
    const target = root.querySelector('.ikao-pdp__floating-card .ikao-pdp__meta > span:first-child');
    if (target) target.dataset.ikaoPdpSkuTarget = 'true';
    return target;
  };

  const currentVariantId = root => {
    const desktopInput = root.querySelector('.ikao-pdp__floating-card [data-variant-input]');
    const anyInput = root.querySelector('[data-variant-input]');
    return Number(desktopInput?.value || anyInput?.value || 0);
  };

  const syncRoot = root => {
    if (!root) return;
    const data = readMap(root);
    const target = targetFor(root);
    const id = currentVariantId(root);
    if (!target || !id || !Array.isArray(data.variants)) return;

    const variant = data.variants.find(item => Number(item.id) === id);
    const nextText = String(variant?.sku || id || '').trim();
    if (nextText && target.textContent.trim() !== nextText) target.textContent = nextText;
  };

  const scheduleSync = root => {
    if (!root) return;
    window.requestAnimationFrame(() => syncRoot(root));
    window.setTimeout(() => syncRoot(root), 80);
  };

  const initRoot = root => {
    if (!root || root.dataset.ikaoPdpSkuFix === 'true') return;
    root.dataset.ikaoPdpSkuFix = 'true';
    scheduleSync(root);

    root.addEventListener('click', event => {
      if (event.target.closest('[data-color], [data-size]')) scheduleSync(root);
    }, true);

    root.addEventListener('change', event => {
      if (event.target.matches('[data-variant-input]')) scheduleSync(root);
    }, true);
  };

  const run = () => document.querySelectorAll('[data-ikao-pdp]').forEach(initRoot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();

  } catch(e) { console.error(e); }
})();
})();
